module.exports = __webpack_public_path__ + "img/rongYu11.26abadda.png";